<div class="expanded-panel-header purple" (click)="toggleExpand()">Loans</div>
@if(expanded){
  <div class="row">
    <table>
      <thead>
        <tr>
          <th>Lender</th>
          <th>Amount</th>
          <th>Type</th>
          <th>Available</th>
        </tr>
      </thead>
      <tbody>
        @for(loan of loans; track $index){
          <tr>
            <td>{{loan.lender ?? '--'}}</td>
            <td>{{loan.amount ? (loan.amount | currency: 'USD': 'symbol': '1.0-0' ) : '--' }}</td>
            <td>{{loan.loan_type ?? '--'}}</td>
            <td>{{loan.available !== null ? loan.available ? 'Yes' : 'No' : '--'}}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
